import { TaInput } from '@components/shared';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import { Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const LocationInput = ({
	formik,
	loading,
	openMapsModal,
}: {
	formik: any;
	loading: boolean;
	openMapsModal: () => void;
}) => {
	const { t } = useTranslation();

	return (
		<div className="w-full">
			{loading ? (
				<Skeleton variant="rectangular" width="100%" sx={{ borderRadius: '8px' }} height={42} />
			) : (
				<TaInput
					click={openMapsModal}
					endIcon={<FmdGoodOutlinedIcon />}
					id="crop_location_name"
					readonly={true}
					label={t('myFarm.farmLocation')}
					size="small"
					value={formik.values.crop_location_name}
					onChange={formik.handleChange}
					error={formik.errors.crop_location_name}
					touched={formik.touched.crop_location_name}
				/>
			)}
		</div>
	);
};
